import ApiConnector         from '@/models/ApiConnector';
import { Collection }       from '@mathquis/modelx';
import { ConnectorResult }  from '@mathquis/modelx';
import { ConnectorResults } from '@mathquis/modelx';
import { Model }            from '@mathquis/modelx';
import _get                 from 'lodash/get';

export default class MonolithConnector extends ApiConnector {
	protected _authorizationHeaderName = 'X-Platform-Authorization';
	public resultTotalPath = '[0].AppPagination.total_count';

	public async fetch(model: Model, options: object = {}) {
		const customOptions = { method: 'get', ...options };
		const response = await this.request(model.path, customOptions);
		const result = Object.values(_get(response, 'data.0', {})).at(0) as any;
		return new ConnectorResult(result, response);
	}

	public async list<T extends Model>(collection: Collection<T>, options: ConnectorListOptions = {}) {
		const customOptions = { method: 'get', ...options, headers: { ...options.headers } };

		const response = await this.requestList(collection.path, customOptions);

		const data = _get(response, 'data.0.AppPagination.items', [])
			.map((i: any) => Object.values(i).at(0));

		return new ConnectorResults(data || [], response);
	}

	protected request(path: string, options: Record<string, unknown> = {}) {
		const params = (options.params || {}) as any;

		if (params.itemsPerPage) {
			params.step = params.itemsPerPage;
			delete params.itemsPerPage;
		}

		return super.request(path, options);
	}
}
